if (!customElements.get('bio-doctors')) {
  customElements.define(
    'bio-doctors',
    class BioDoctors extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')].filter((video) => !video.closest('[data-bd-player]'));
        this.dialog = this.querySelector('[data-bd-dialog]');
        this.player = this.querySelector('[data-bd-player]');

        if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.play().catch(() => {});
                } else {
                  entry.target.pause();
                }
              });
            },
            { threshold: 0.5 }
          );
          this.videos.forEach((video) => this.observer.observe(video));
        }

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-bd-close]') || event.target === this.dialog) {
            this.closeVideo();
            return;
          }
          const open = event.target.closest('[data-bd-open]');
          if (open) this.openVideo(open.closest('.bd__card').querySelector('video'));
        });
        this.dialog.addEventListener('close', () => {
          this.player.replaceChildren();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      openVideo(video) {
        if (!video) return;
        const copy = video.cloneNode(true);
        copy.removeAttribute('muted');
        copy.removeAttribute('loop');
        copy.muted = false;
        copy.controls = true;
        copy.preload = 'auto';
        this.player.replaceChildren(copy);
        this.dialog.showModal();
        copy.play().catch(() => {});
      }

      closeVideo() {
        this.dialog.close();
      }
    }
  );
}

if (!customElements.get('bio-timeline')) {
  customElements.define(
    'bio-timeline',
    class BioTimeline extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-bt-list]');
        this.fill = this.querySelector('[data-bt-fill]');
        this.items = [...this.querySelectorAll('[data-bt-item]')];
        this.dialog = this.querySelector('[data-bt-dialog]');
        this.queued = false;

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-bt-open]')) this.dialog?.showModal();
          if (event.target.closest('[data-bt-close]') || event.target === this.dialog) this.dialog?.close();
        });

        const videos = this.querySelectorAll('[data-bt-video]');
        if (videos.length && 'IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.play().catch(() => {});
                } else {
                  entry.target.pause();
                }
              });
            },
            { threshold: 0.4 }
          );
          videos.forEach((video) => this.videoObserver.observe(video));
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.measure();
          return;
        }
        this.classList.add('is-live');
        this.onScroll = () => {
          if (this.queued) return;
          this.queued = true;
          requestAnimationFrame(() => {
            this.queued = false;
            this.update();
          });
        };
        this.onResize = () => {
          this.measure();
          this.onScroll();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.videoObserver?.disconnect();
      }

      measure() {
        const last = this.items[this.items.length - 1];
        if (!last) return;
        const listTop = this.list.getBoundingClientRect().top;
        this.railHeight = last.getBoundingClientRect().top - listTop;
        this.list.style.setProperty('--bt-rail', `${this.railHeight}px`);
      }

      update() {
        const line = window.innerHeight * 0.62;
        const top = this.list.getBoundingClientRect().top + 15;
        const progress = this.railHeight ? Math.min(1, Math.max(0, (line - top) / this.railHeight)) : 0;
        this.fill.style.transform = `scaleY(${progress})`;
        this.items.forEach((item) => {
          item.classList.toggle('is-on', item.getBoundingClientRect().top + 15 <= line);
        });
      }
    }
  );
}
